export const testimonials = [
  {
    name: 'Leanne Gillies',
    role: 'Research & Innovation Manager',
    text: 'This is new, this is different and it benefits the whole supply chain',
    img: 'general/avatars/leanne.png'
  },
  {
    name: 'Erik van Zuilekom',
    role: 'Proprietor/Founder of UnitedNatures',
    text: "This is great—I'm a visual person and everything is seamless",
    img: 'general/avatars/eric.jpeg'
  },
  {
    name: 'David Reid',
    role: 'Consultant',
    text: "I like what you're doing, you've spoken to the right people",
    img: 'general/avatars/david.jpg'
  },
  {
    name: 'Mathew Plummer',
    role: 'Owner, EvergreenConnect',
    text: "I trust you guys and I support this because it can benefit the whole industry",
    img: 'general/avatars/mat.png'
  },
  {
    name: 'Azin Emampour',
    role: 'Senior Associate Landscape Architect | AILA Vic Executive',
    text: 'This is the future. You are the only ones who can do it',
    img: 'general/avatars/azin.jpg'
  },
  {
    name: 'Daniel Fuller, MAIH',  
    role: 'Horticulture consultant, writer, podcaster',
    text: "Every path you've gone down, I'm with you 100%—even just the maintenance is worth paying for especially for councils",
    img: 'general/avatars/DanielFuller.png'
  },
  {
    name: 'Hugh Burley',
    role: 'Spatial Architect, Accenture',
    text: "So many good things will come out of this",
    img: 'general/avatars/HughBurley.jpeg'
  },
  {
    name: 'Carl Soderlund',
    role: 'President, Nursery and Garden Industry Victoria',
    text: "This is a great initiative",
    img: '/general/avatars/CarlSoderlund.jpeg'
  },
  {
    name: 'Alan Burnell',
    role: 'President, Australian Institute of Horticulture',
    text: "It's brilliant",
    img: '/general/avatars/AlanBurnell.jpeg'
  },
  {
    name: 'Clair Farrell',
    role: 'Associate Professor (Green Infrastructure)',
    text: "What you guys are doing is so powerful",
    img: '/general/avatars/ClaireFarrell.jpg'
  },
  
]
